import { useContext, useEffect } from 'react';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import GridProvider from './components/GridProvider';
import { TabContext } from '../../../Context/TabContext';
import { currencyFormatDE } from '../../../../utils/currencyFormat';
import { useTranslation } from 'react-i18next';

const DobitPoRadnimNalozima = () => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { sendRequest, data, isLoading } = useHttp('');

  const vratiGrid = () => {
    sendRequest({ url: urls.GET_DOBIT });
  };
  useEffect(() => {
    vratiGrid();
  }, []);
  const handleOpenZahtev = (id) => {
    // console.log(item);
    const tab = {
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      type: 10014,
      data: { idDok: id },
    };
    addTab(tab);
  };
  const handleClickDokument = (item) => {
    const tab = {
      title: 'Detalji radnog naloga',
      icon: 'fas fa-chart-pie',
      type: 10016,
      data: item,
    };
    addTab(tab);
  };
  return (
    <div>
      <GridProvider
        data={data}
        isLoading={isLoading}
        handleClickDokument={handleClickDokument}
        handleOpenZahtev={handleOpenZahtev}
      />
      {/* <div style={{ width: '73%', textAlign: 'right' }}>
        <labe style={{ textAlign: 'right' }}>{t('total')}: </labe>
        <label>
          {currencyFormatDE(
            data.reduce((sum, item) => sum + item.ukupnaDobit, 0),
          )}{' '}
        </label>
      </div> */}
    </div>
  );
};

export default DobitPoRadnimNalozima;
